import * as types from '../types'

/**
 * 商品详情页
 * base 商品基本信息
 * proms 商品促销规则
 * isFavor 前用户是否喜欢
 * @type {Object}
 */
const state = {
    base: {
        brand: {name: ''},
        spec: '',
        specs: [],
        sku_arr: {}
    },
    proms: '',
    livestock: {},
    parts: [],
    isFavor: 0
}

const getters = {

}

const actions = {

}

const mutations = {
    [types.CHANGE_GOODS] (state, data) {
        state.base          =   (data.goods) ? data.goods : {'brand': {'name': ''}}
        state.base.brand    =   (data.goods.brand) ? data.goods.brand : {'name': ''}
        state.proms         =   (data.goodsProms) ? data.goodsProms : ''
        state.isFavor       =   (data.isFavor) ? data.isFavor : 0

        //若商品为多规格,修改参数
        if (state.base.specs != []) {
            for(let i in state.base.specs) {
                state.base.specs[i]['value'] = state.base.specs[i]['value'].split(',')

                if (state.base.specs[i]['style'] == 2) {
                    state.base.specs[i]['img'] = state.base.specs[i]['img'].split(',')
                } else if (state.base.specs[i]['style'] == 1) {
                    state.base.specs[i]['color'] = state.base.specs[i]['color'].split(',')
                }
            }
        }
        if (state.base.spec && state.base.spec != '') {
            state.base.spec = JSON.parse(state.base.spec)
        } else {
            state.base.spec = []
        }
    },

    [types.CHANGE_LIVESTOCK] (state, data) {
        state.livestock = (data.livestock) ? data.livestock : {}
        state.parts = (data.parts) ? data.parts : []
    },

    [types.UPDATE_IS_FAVOR] (state, bool) {
        state.isFavor = bool
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/goods.js